import * as React from 'react';

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener('change', onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return !!isMobile;
}

let mobileAtLoad: boolean | undefined;

/**
 * Viewport móvil fijado al cargar la página: se mide la primera vez y no
 * cambia al redimensionar hasta recargar. Así cada tabla monta una sola vista
 * y todas las de la página coinciden (IT-119).
 */
export function useIsMobileAtLoad() {
  if (mobileAtLoad === undefined) {
    mobileAtLoad = typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT;
  }
  return mobileAtLoad;
}
